import angular from 'angular';

var bodyPaddingRemover = function() {
 	return {
 		restrict: 'A',
 		link: function(scope, elem, attr) {
 			angular.element('body').css('padding-top', '0');
 		}
 	};
 };

export default angular.module('app.bodyPaddingRemover', [])
	.directive('bodyPaddingRemover', bodyPaddingRemover)
	.name;